export default "__VITE_ASSET__CFx8E9d0__"